import { type Shift } from "@src/appV2/Shifts/Shift/types";
import { parseISO } from "date-fns";
import { useMemo } from "react";

export interface TimesheetEntry {
  clockInTime: Date;
  clockOutTime: Date;
  breakStartTime?: Date;
  breakEndTime?: Date;
}

export function useTimesheetEntry(shift?: Shift): TimesheetEntry | undefined {
  return useMemo(() => {
    if (!shift?.clockInOut?.start || !shift?.clockInOut?.end) {
      return undefined;
    }

    const clockInTime = parseISO(shift.clockInOut.start);
    const clockOutTime = parseISO(shift.clockInOut.end);

    return {
      clockInTime,
      clockOutTime,
      breakStartTime: shift.lunchInOut?.start ? parseISO(shift.lunchInOut.start) : undefined,
      breakEndTime: shift.lunchInOut?.end ? parseISO(shift.lunchInOut.end) : undefined,
    };
  }, [
    shift?.clockInOut?.start,
    shift?.clockInOut?.end,
    shift?.lunchInOut?.start,
    shift?.lunchInOut?.end,
  ]);
}
